import { render, staticRenderFns } from "./DutySituation.vue?vue&type=template&id=65cbd048&scoped=true&"
import script from "./DutySituation.vue?vue&type=script&lang=js&"
export * from "./DutySituation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cbd048",
  null
  
)

export default component.exports